if ( ! window.LastuCart ) {

	window.LastuCart = {

		_refreshPromise: null,
		_pendingOpenDrawer: false,

		showDrawer(){
			document.querySelector('[data-js-site-cart-sidebar]')?.show();
		},

		applySectionMarkup(text, openDrawer = false){

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartItems = document.getElementById('AjaxCartForm');
			const cartSubtotal = document.getElementById('AjaxCartSubtotal');
			const nextCartItems = sectionInnerHTML.getElementById('AjaxCartForm');
			const nextCartSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');

			if ( nextCartItems && cartItems ) {
				cartItems.innerHTML = nextCartItems.innerHTML;
				cartItems.ajaxifyCartItems?.();
			}

			if ( nextCartSubtotal && cartSubtotal ) {
				cartSubtotal.innerHTML = nextCartSubtotal.innerHTML;
			}

			const cartCount = cartItems?.querySelector('[data-cart-count]')?.textContent || '0';
			const cartTotal = cartItems?.querySelector('[data-cart-total]')?.textContent || '';

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartCount;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				elm.textContent = cartTotal;
			});

			const sidebar = document.querySelector('[data-js-site-cart-sidebar]');
			const form = cartItems?.querySelector('form');
			const isEmpty = !! form?.classList.contains('cart--empty');

			if ( sidebar ) {
				sidebar.classList.toggle('cart-is-empty', isEmpty);
				sidebar.setAttribute('data-cart-items', cartCount);
			}

			document.querySelector('.cart-section')?.classList.toggle('cart-section--empty', isEmpty);

			if ( openDrawer ) {
				this.showDrawer();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

			cartItems?.dispatchEvent(new Event('cart-updated'));
			document.dispatchEvent(new CustomEvent('lastu:cart:rendered', {
				detail: {
					openDrawer,
					isEmpty,
					cartCount
				}
			}));

			return {
				cartItems,
				cartSubtotal,
				sectionInnerHTML
			};

		},

		// Stub methods called by component-product-form.js (fail-safe stubs)
		markRefreshRequested(){},
		markRendered(){},

		refresh(openDrawer = true, options = {}){

			const config = typeof openDrawer === 'object' ? openDrawer : {
				openDrawer,
				...options
			};

			const shouldOpenDrawer = config.openDrawer !== false;
			const immediateOpen = shouldOpenDrawer && config.immediateOpen !== false;

			if ( shouldOpenDrawer ) {
				this._pendingOpenDrawer = true;
			}

			if ( immediateOpen ) {
				this.showDrawer();
			}

			if ( this._refreshPromise ) {
				return this._refreshPromise;
			}

			this._refreshPromise = fetch('?section_id=helper-cart')
				.then(response => response.text())
				.then(text => {
					const result = this.applySectionMarkup(text, this._pendingOpenDrawer);
					this._pendingOpenDrawer = false;
					return result;
				})
				.catch(error => {
					this._pendingOpenDrawer = false;
					throw error;
				})
				.finally(() => {
					this._refreshPromise = null;
				});

			return this._refreshPromise;

		}

	};

}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			const prefix = window.KT_PREFIX || '';

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector(`.${prefix}remove`);
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector(`.${prefix}qty`);
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

			const clearBtn = this.querySelector('[data-js-clear-cart]');
			if (clearBtn) {
				clearBtn.addEventListener('click', () => {
					const prefix = window.KT_PREFIX || '';
					this.form.classList.add(`${prefix}processing`);
					fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
						.then(() => window.LastuCart.refresh({ openDrawer: false, immediateOpen: false }))
						.catch(() => this.form.classList.remove(`${prefix}processing`));
				});
			}

		}

		updateCartQty(item, newQty){

			let alert = null;
			const prefix = window.KT_PREFIX || '';
			const targetLine = parseInt(item.dataset.line);
			const targetKey = item.dataset.id;

			this.form.classList.add(`${prefix}processing`);
			if ( this.querySelector(`.${prefix}alert`) ) {
				this.querySelector(`.${prefix}alert`).remove();
			}

			// When removing an item (qty=0), also remove any associated Customily option
			// items that share the same _customily-id group, plus any orphaned option items
			// (options left over from previous add-to-cart attempts with no matching main product).
			const buildRemovalRequest = () => {
				return fetch('/cart.js')
					.then(r => r.json())
					.then(cart => {
						const cartItems = cart.items;

						// Find the item being removed by key, fall back to line index
						const targetCartItem = cartItems.find(ci => ci.key === targetKey) || cartItems[targetLine - 1];
						if (!targetCartItem) {
							return { type: 'change', line: targetLine, quantity: 0 };
						}

						const mainGroupId = (targetCartItem.properties || {})['_customily-upsell-main-id'];

						// Collect group IDs that will still have a main product after this removal
						const remainingGroupIds = new Set();
						cartItems.forEach(ci => {
							if (ci.key === targetCartItem.key) return;
							const gid = (ci.properties || {})['_customily-upsell-main-id'];
							if (gid) remainingGroupIds.add(gid);
						});

						// Build lines to zero out
						const updates = {};
						updates[targetLine] = 0;

						cartItems.forEach((ci, idx) => {
							const line = idx + 1;
							if (line === targetLine) return;
							const upsellId = (ci.properties || {})['_customily-upsell-id'];
							if (!upsellId) return;

							// Remove if it belongs to the group being removed, OR if it is an
							// orphan (its group has no main product remaining in the cart).
							if (
								(mainGroupId && upsellId === mainGroupId) ||
								!remainingGroupIds.has(upsellId)
							) {
								updates[line] = 0;
							}
						});

						if (Object.keys(updates).length === 1) {
							return { type: 'change', line: targetLine, quantity: 0 };
						}

						return { type: 'update', updates };
					})
					.catch(() => ({ type: 'change', line: targetLine, quantity: 0 }));
			};

			const doSingleRemove = () => fetch(KROWN.settings.routes.cart_change_url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
				body: JSON.stringify({ line: targetLine, quantity: 0 })
			}).then(r => r.json());

			const executeRequest = (newQty !== 0)
				? fetch(KROWN.settings.routes.cart_change_url, {
						method: 'POST',
						headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
						body: JSON.stringify({ line: targetLine, quantity: newQty })
					}).then(r => r.json())
				: buildRemovalRequest().then(req => {
						if (req.type === 'update') {
							return fetch('/cart/update.js', {
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body: JSON.stringify({ updates: req.updates })
							}).then(r => r.json()).then(response => {
								// If bulk update fails (e.g. orphaned item with deleted variant),
								// fall back silently to removing only the main item.
								if (response.status == 422) return doSingleRemove();
								return response;
							});
						}
						return doSingleRemove();
					});

			executeRequest
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						KROWN.functions.eventDispatcher('krown:cart:error', {
							error: alert.textContent
						});
					}
					return window.LastuCart.refresh({
						openDrawer: false,
						immediateOpen: false
					});
				})
				.then(result => {

					const cartItems = result?.cartItems || document.getElementById('AjaxCartForm');
					const activeForm = cartItems?.querySelector('form');

					if ( alert !== null && activeForm ) {
						activeForm.prepend(alert);
					}

					const updatedItem = cartItems?.querySelector(`[data-js-cart-item][data-line="${targetLine}"]`);
					if ( updatedItem ) {
						KROWN.functions.eventDispatcher('krown:cart:update', {
							itemKey: updatedItem.dataset.id,
							itemQty: updatedItem.dataset.qty,
							itemVariantId: updatedItem.dataset.variant,
							itemProductId: updatedItem.dataset.productId
						});
					}

				})
				.catch(e => {
					console.log(e);
					let errAlert = document.createElement('span');
					errAlert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
					errAlert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(errAlert);
				})
				.finally(() => {
					this.form.classList.remove(`${prefix}processing`);
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this._prefix = window.KT_PREFIX || '';
			this.querySelector(`.${this._prefix}qty-minus`).addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector(`.${this._prefix}qty-plus`).addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector(`.${this._prefix}qty`).value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = (openDrawer = true, options = {}) => {
		return window.LastuCart.refresh(openDrawer, options);
	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {

				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');
				this._prefix = window.KT_PREFIX || '';
				this.loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add(`${this._prefix}processing`);
						if (this.discountCodes) {
							this.discountCodes.classList.add(`${this._prefix}processing`);
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.handleSuccess();
									} else {
										this.handleError();
									}
								} else {
									this.handleError();
								}
							})
							.catch(error => {
								this.handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
						this.cartSubtotal.innerHTML = cartSubtotalInnerHTML;
						this.cartSubtotal.classList.remove(`${this._prefix}processing`);
						this.cartDiscountError.innerHTML = '';
						if ( sectionInnerHTML.querySelector('[data-js-discount-codes]') ) {
							this.discountCodes.innerHTML = sectionInnerHTML.querySelector('[data-js-discount-codes]').innerHTML;
							this.discountCodes.classList.remove(`${this._prefix}processing`);
							this.loadDiscountButtons();
						}
						this.input.value = '';
					})
			}

			loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains(`${this._prefix}enabled`) ) {
						elm.classList.add(`${this._prefix}enabled`);
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add(`${this._prefix}processing`);
							if (this.discountCodes) {
								this.discountCodes.classList.add(`${this._prefix}processing`);
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			handleError(){
				this.cartSubtotal.classList.remove(`${this._prefix}processing`);
				if (this.discountCodes) {
					this.discountCodes.classList.remove(`${this._prefix}processing`);
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}
